export const GET_EXERCISE_RECOMMENDATIONS = "GET_EXERCISE_RECOMMENDATIONS";
export const GET_EXERCISE_RECOMMENDATIONS_SUCCESS =
  "GET_EXERCISE_RECOMMENDATIONS_SUCCESS";
export const GET_EXERCISE_RECOMMENDATIONS_FAIL =
  "GET_EXERCISE_RECOMMENDATIONS_FAIL";

export const ASSIGN_EXERCISE = "ASSIGN_EXERCISE";
export const ASSIGN_EXERCISE_SUCCESS = "ASSIGN_EXERCISE_SUCCESS";
export const ASSIGN_EXERCISE_FAIL = "ASSIGN_EXERCISE_FAIL";

export const UNASSIGN_EXERCISE = "UNASSIGN_EXERCISE";
export const UNASSIGN_EXERCISE_SUCCESS = "UNASSIGN_EXERCISE_SUCCESS";
export const UNASSIGN_EXERCISE_FAIL = "UNASSIGN_EXERCISE_FAIL";

// Fetch exercise recommendations for a patient
export const getExerciseRecommendations = (patient_id) => ({
  type: GET_EXERCISE_RECOMMENDATIONS,
  payload: {
    request: {
      method: "get",
      url: `/cdss/exercise-recommendations/patient/${patient_id}/`,
    },
  },
});

// Assign an exercise to the patient
export const assignExercise = (exercise_recommendation_id, patient_id) => ({
  type: ASSIGN_EXERCISE,
  payload: {
    request: {
      method: "post",
      url: `/cdss/exercise-recommendations/${exercise_recommendation_id}/assign/patient/${patient_id}/`,
    },
  },
});

// Unassign an exercise from the patient
export const unassignExercise = (exercise_recommendation_id, patient_id) => ({
  type: UNASSIGN_EXERCISE,
  payload: {
    request: {
      method: "post",
      url: `/cdss/exercise-recommendations/${exercise_recommendation_id}/unassign/patient/${patient_id}/`,
    },
  },
});
